import { render, staticRenderFns } from "./item_type.vue?vue&type=template&id=6a27ff4a&scoped=true&"
import script from "./item_type.vue?vue&type=script&lang=js&"
export * from "./item_type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a27ff4a",
  null
  
)

export default component.exports